import * as React from "react";
import * as S from "@styled";
import { ITriggerDescription } from "../model/Process";
import TriggerDisplay from "./TriggerDisplay";

export const ProcessTriggersDisplay: React.FC<ProcessTriggerDisplayProps> = (props) => {

    if (!props.processActive) {
        return <span style={{ fontSize: "14px" }}>{FRENDS.Localizations.NotActive}</span>;
    }
    return (
        <S.FlexContainer gap={5}>
            {props.triggers.map((t, i) =>
                <TriggerDisplay
                    key={t.name + i}
                    processId={props.processId}
                    triggerDescription={t.description}
                    triggerName={t.name}
                    triggerType={t.type}
                    processVersion={props.processVersion}
                    processActive={props.processActive}
                />)}
        </S.FlexContainer>
    );
};

export interface ProcessTriggerDisplayProps {
    processId: string;
    triggers: ITriggerDescription[];
    processActive: boolean;
    processVersion: number;
}
